import styled from "styled-components";
import { palette, size } from "styled-theme";

const Wrapper = styled.div`
  .textArea {
    display: flex;
    padding: 10px 0;
    min-height: 100px;
    flex-direction: column;
    position: relative;
    margin-bottom: 18px;
  }
  .textArea-Label-Container {
    display: flex;
    width: fit-content;
  }
  .textArea-Label {
    display: inline-flex;
    padding-left: 3px;
    padding-bottom: 7px;
    color: ${palette("formInputElement", 0)};
    font-weight: 400;
    font-size: ${size("p0")};
  }
  .textArea-Label-Optional {
    padding-left: 6px;
    font-size: ${size("p3")};
    color: ${palette("grayscale", 15)};
    font-weight: 700;
  }
  .textArea-Input {
    display: flex;
    min-height: 100px;
    padding: 5px;
    border: 1px solid ${palette("formInputElement", 1)};
    border-radius: 5px;
    margin: 0 !important;
  }

  .textArea-Input textarea {
    display: inline-block;
    border: none;
    width: 98%;
    height: 98%;
    font-size: ${size("p0")};
    color: ${palette("formInputElement", 0)};
    text-overflow: ellipsis;
    padding: 10px;
    background-color:${palette("formInputElement", 5)};
  }
  .textArea-Input textarea:focus {
    outline: none;
  }
  .required:focus-within {
    box-shadow: 0 0 6px ${palette("color", 18)};
    outline: none;
  }
  .textArea-Input:focus-within:not(.required) {
    box-shadow: 0 0 6px ${palette("input", 0)};
  }
  .required {
    border: 2px solid ${palette("error", 4)}!important;
  }
  .textArea-Input textarea::placeholder {
    color: gray;
    font-weight: lighter;
  }

  .validation-message {
    top: auto;
    bottom: -18px;
    margin-top: 5px;
  }
`;

export default Wrapper;
